module.exports = new __parcel__URL__("limbnumbingcurse.ba97b00b.png").toString();